import { render, staticRenderFns } from "./LogisticDetail.vue?vue&type=template&id=cb4b33e2&scoped=true"
import script from "./LogisticDetail.vue?vue&type=script&lang=js"
export * from "./LogisticDetail.vue?vue&type=script&lang=js"
import style0 from "./LogisticDetail.vue?vue&type=style&index=0&id=cb4b33e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb4b33e2",
  null
  
)

export default component.exports